import createReactClass from "create-react-class";
import React from "react";
import Loader from "./loader";
import NecessariesItem from "./necessaries_item";
export default createReactClass({
  displayName: "Root",
  loadNotificationListFromServer() {
    this.setState({ loading: true });
    var companyId = (typeof this.props.companyId === 'undefined') ? null : this.props.companyId;
    $.ajax({
      url: "/api/notification/necessaries",
      data: {
        company_id: companyId,
      },
      dataType: "json",
      cache: false,
      success: function(data) {
        // var display = data.necessaries.length == 0 ? "block" : "block";
        this.setState({
          loading: false,
          necessariesList: data,
          uncheckedNotificationCount: 0,
        });
      }.bind(this),
      error: function() {
        this.setState({ loading: false });
      }.bind(this),
    });
  },
  // setIsCheckedToServer() {
  //   $.ajax({
  //     url: "/api/notification/necessaries_is_checked",
  //     dataType: "json",
  //     type: "POST",
  //     headers: {
  //       "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
  //     },
  //     cache: false,
  //     success: function() {}.bind(this),
  //     error: function() {}.bind(this),
  //   });
  // },
  getInitialState() {
    return {
      loading: true,
      necessariesList: { necessaries: [] },
    };
  },
  componentDidMount() {
    this.loadNotificationListFromServer();
    // this.setIsCheckedToServer();
  },
  render() {
    var necessariesTitleWidth = this.state.necessariesTitleWidth;
    var necessariesItems = this.state.necessariesList.necessaries && this.state.necessariesList.necessaries.length > 0  ? (
      this.state.necessariesList.necessaries.map(function(item) {
        return (
          <NecessariesItem
            necessariesItem={item}
            necessariesTitleWidth={necessariesTitleWidth}
            key={item.id}
          />
        );
      })
    ) : (
      <li className="notif-2026__empty">
        <span className="notif-2026__empty-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
            <path d="m9 14 2 2 4-4" />
          </svg>
        </span>
        <span className="notif-2026__empty-title">現在表示できるやることリストはありません</span>
        <span className="notif-2026__empty-lead">ご利用にあたって確認や対応をお願いする内容がある場合は、こちらに表示されます。</span>
      </li>
    );
    var necessariesList = (
      <div style={{ padding: "0" }}>
        <div>
        {this.state.loading ? (
            <Loader isActive={this.state.loading} />
            ) : necessariesItems
          }
        </div>
      </div>
    );
    return <div>{necessariesList}</div>;
  },
});